import React from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import { GlobalContext } from '../../Context/Global.context';
import ProgressIndicator from '../../Components/ProgressIndicator';

import API from '../../Util/api';
import debounce from 'es6-promise-debounce';
import { IsMobile } from '../../Util/MobileDetector';

import {
  GetProjectGroupPathForApi,
  GetProjectMembersPathForApi,
  GetProjectGroupMembersPathForApi,
} from '../../Util/api';

const styles = theme => ({
  dialogPaper: {
    height:(!IsMobile()) ? "80%" : undefined,
  },
  dialogTitle: {
  },
  dialogContent: {
  },
  dialogActions: {
  },
  contentContainer: {
    marginTop:theme.spacing(2),
    "& .MuiListItem-gutters": {
      paddingLeft: 0,
    },
  },
  membersList: {
    maxHeight: '300px',
    overflow: 'auto',
  },
});

class ProjectGroupDialog extends React.Component {
  static contextType = GlobalContext;

  constructor(props) {
    super(props);

    this.state = {
      open: props.open,
      ProjectGroup: props.ProjectGroup,
      ShowProgressIndicator: false,
      projectMembers: [],
      projectGroupMembers: [],
      nameValue: props.ProjectGroup ? props.ProjectGroup.Name : '',
    }
  }

  handleClose = () => {
    this.setState({
      open: false,
    });
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  updateProjectGroup = ProjectGroup => {
    this.setState({ProjectGroup});
    this.handleUpdateServerProjectGroup(ProjectGroup);
    if (ProjectGroup && this.props.onProjectGroupRevised) {
      this.props.onProjectGroupRevised({...ProjectGroup});
    }
  }

  handleUpdateServerProjectGroup = debounce(projectGroup => {
    if (!this.props.ProjectGroup) {
      return;
    }
    if (!projectGroup) {
      projectGroup = {...this.state.ProjectGroup};
    }

    API.put(GetProjectGroupPathForApi(projectGroup.OrganizationID, projectGroup.ProjectID,
      projectGroup.ID), projectGroup)
      .then(resp => {
        this.setState({
          // ProjectGroup: resp.data,
        });
      })
      .catch(this.handleApiError);
  }, 250);

  handleNameChange = (event) => {
    const nameValue = event.target.value;
    this.setState({ nameValue });
    
    // Update the project group with the new name
    const updatedProjectGroup = { ...this.state.ProjectGroup, Name: nameValue };
    this.updateProjectGroup(updatedProjectGroup);
  }

  handleToggleMember = (memberId, memberEmail) => {
    const { projectGroupMembers, ProjectGroup } = this.state;

    // Check if member is already in the group
    const projectGroupMember = projectGroupMembers.find(m => m.UserEmail === memberEmail);
    const isMemberInGroup = Boolean(projectGroupMember);
    
    if (isMemberInGroup) {
      // Remove member from group
      this.setState({ ShowProgressIndicator: true });
      API.delete(GetProjectGroupMembersPathForApi(ProjectGroup.OrganizationID, ProjectGroup.ProjectID, ProjectGroup.ID), 
        { data: { IDs: [projectGroupMember.ID] } })
        .then(() => {
          // Update the list of members in the group
          this.loadProjectGroupMembers();
        })
        .catch(this.handleApiError);
    } else {
      // Add member to group
      this.setState({ ShowProgressIndicator: true });
      API.post(GetProjectGroupMembersPathForApi(ProjectGroup.OrganizationID, ProjectGroup.ProjectID, ProjectGroup.ID), 
        [{ ProjectMemberID: memberId }])
        .then(() => {
          // Update the list of members in the group
          this.loadProjectGroupMembers();
        })
        .catch(this.handleApiError);
    }
  }

  loadProjectMembers = () => {
    const { ProjectGroup } = this.state;
    if (!ProjectGroup) return;
    
    this.setState({ ShowProgressIndicator: true });
    API.get(GetProjectMembersPathForApi(ProjectGroup.OrganizationID, ProjectGroup.ProjectID), 
      { params: { getAll: true } })
      .then(resp => {
        this.setState({
          projectMembers: resp.data.ProjectMembers || [],
          ShowProgressIndicator: false,
        });
      })
      .catch(this.handleApiError);
  }

  loadProjectGroupMembers = () => {
    const { ProjectGroup } = this.state;
    if (!ProjectGroup) return;
    
    this.setState({ ShowProgressIndicator: true });
    API.get(GetProjectGroupMembersPathForApi(ProjectGroup.OrganizationID, ProjectGroup.ProjectID, ProjectGroup.ID), 
      { params: { getAll: true } })
      .then(resp => {
        this.setState({
          projectGroupMembers: resp.data.ProjectGroupMembers || [],
          ShowProgressIndicator: false,
        });
      })
      .catch(this.handleApiError);
  }

  handleApiError = err => {
    this.setState({ShowProgressIndicator: false});
    this.props.onApiError(err);
  }

  componentDidMount() {
    if (this.state.ProjectGroup) {
      this.loadProjectMembers();
      this.loadProjectGroupMembers();
    }
  }

  componentDidUpdate(prevProps) {
    if (typeof this.props.open !== "undefined"
      && prevProps.open !== this.props.open) {
      let stateToUpdate = {
        open: this.props.open !== false,
      }
      if (this.props.open) {
        if (this.props.ProjectGroup) {
          stateToUpdate.ProjectGroup = this.props.ProjectGroup;
          stateToUpdate.nameValue = this.props.ProjectGroup.Name;
          
          // Load members when dialog opens with a project group
          this.setState(stateToUpdate, () => {
            this.loadProjectMembers();
            this.loadProjectGroupMembers();
          });
          return;
        } else {
          stateToUpdate.ProjectGroup = null;
        }
      } else {
        stateToUpdate.ProjectGroup = null;
      }
      this.setState(stateToUpdate);
    }
  }

  render() {
    const {
      open,
      ProjectGroup,
      ShowProgressIndicator,
      nameValue,
      projectMembers,
      projectGroupMembers,
    } = this.state;
    const {
      classes,
      theme,
      showProgressIndicatorImmediately,
    } = this.props;
    const {
      CompletedGET,
    } = this.context;

    if (!CompletedGET.UserPreferences) {
      return null;
    }

    const dialogActions = (
      <DialogActions className={classes.dialogActions}>
        <Button onClick={() => this.handleClose()}>
          CLOSE
        </Button>
      </DialogActions>
    );

    const progressIndicator = (ShowProgressIndicator || showProgressIndicatorImmediately)
      ? (
        <ProgressIndicator showImmediately={showProgressIndicatorImmediately} />
      )
      : null;

    const content = ProjectGroup ? (
      <React.Fragment>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <TextField
              fullWidth
              label="Group Name"
              variant="outlined"
              value={nameValue}
              onChange={this.handleNameChange}
            />
          </Grid>
          
          <Grid item style={{marginLeft:theme.spacing(1),marginRight:theme.spacing(1),marginTop:theme.spacing(1)}}>
            <Grid container>
              <Grid item xs={6}>
                <Typography variant="subtitle2">Member</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" align="right">In Group</Typography>
              </Grid>
            </Grid>
            <List className={classes.membersList}>
              {projectMembers.map(member => {
                const isInGroup = projectGroupMembers.some(m => m.UserEmail === member.UserEmail);
                return (
                  <ListItem key={member.ID}>
                    <ListItemText primary={member.UserEmail} />
                    <ListItemSecondaryAction style={{right:0}}>
                      <Switch
                        checked={isInGroup}
                        onChange={() => this.handleToggleMember(member.ID, member.UserEmail)}
                        color="primary"
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              })}
            </List>
          </Grid>
        </Grid>
      </React.Fragment>
    ) : null;

    return (
      <Dialog
        fullScreen={IsMobile()}
        fullWidth={!IsMobile()}
        maxWidth="sm"
        open={open}
        classes={{
          paper:classes.dialogPaper,
        }}
        onClose={() => this.handleClose()}
      >
        <DialogTitle id="dialog-title" className={classes.dialogTitle}>
          Project Group Details
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          {progressIndicator}
          
          <div className={classes.contentContainer}>
            {content}
          </div>

        </DialogContent>
        {dialogActions}
      </Dialog>
    );
  }
}

ProjectGroupDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  ProjectGroup: PropTypes.object,
  onClose: PropTypes.func,
  onApiError: PropTypes.func.isRequired,
  onProjectGroupRevised: PropTypes.func,
};

export default withStyles(styles, {withTheme: true})(ProjectGroupDialog);